import React, { useCallback, useMemo } from "react";
import { R$ } from "src/rifa/utils/brl";
import { getMaxPrizeFromGame } from "src/utils/getMaxPrize";

import SuperTimeCotacoes from "./super-time";
import LoteriaPopularCotacoes from "./loteria-popular";
import ConcursosCotacoes from "./concursos";
import KenoCotacoes from "./keno";

import "src/styles/cotacoes.scss";

export default function Cotacoes({ selectedContest }) {
  const tipoCotacoes = useMemo(() => {
    if (selectedContest.supertimeList) {
      return {
        acertosValor: null,
        nomeValor: selectedContest.supertimeList
          .map((modalidade) => ({
            nome: modalidade.objTipoJogo.vchNome,
            valor: modalidade.objTipoJogo.numValorPagoJogo,
            key: modalidade.objTipoJogo.vchNome,
          }))
          .concat([
            {
              nome: "Time",
              valor: selectedContest.objTipoJogo.numValorPagoJogo,
              key: selectedContest.objTipoJogo.vchNome,
            },
          ]),
      };
    }

    if (selectedContest.objTipoJogo.listModalidade) {
      return {
        acertosValor: null,
        nomeValor: selectedContest.objTipoJogo.listModalidade.map(
          (modalidade) => ({
            nome: modalidade.objTipoJogo.vchNome,
            valor: modalidade.objTipoJogo.numValorPagoJogo,
            key: modalidade.objTipoJogo.vchNome,
          })
        ),
      };
    }

    if (
      selectedContest.lstTamanhoFixo &&
      selectedContest.lstTamanhoFixo.length > 0
    ) {
      const acertosValor = selectedContest.lstTamanhoFixo
        .map((lst) => {
          const chances = lst.lstPagoQtdAcertos
            ? lst.lstPagoQtdAcertos.map((acerto) => {
                return {
                  acertos: acerto.tnyQtdAcertos,
                  valor: acerto.numValorPago,
                  valorMegaBola: acerto.numValorPagoMegaBola,
                };
              })
            : null;

          return {
            tamanho: lst.tnyTamanho / 2,
            premioMaximo: lst.numValorPagoTamanhoFixo,
            chances,
          };
        })
        .sort((a, b) => a.tamanho - b.tamanho);

      return {
        acertosValor,
        nomeValor: null,
      };
    }

    return {
      acertosValor: null,
      nomeValor: [
        {
          valor: getMaxPrizeFromGame(selectedContest),
          nome: selectedContest.objTipoJogo.vchNome
            .toLowerCase()
            .split(" ")
            .map((str) => str.charAt(0).toUpperCase() + str.slice(1))
            .join(" "),
          key: selectedContest.objTipoJogo.vchNome,
        },
      ],
    };
  }, [selectedContest]);

  const RenderCotacoes = useCallback(({ sntTipoJogo }) => {
    if (selectedContest.type === "super-time") {
      return (
        <SuperTimeCotacoes
          tipoCotacoes={tipoCotacoes}
          nomeJogo={selectedContest.objTipoJogo.vchNome.toLowerCase()}
          type={selectedContest.type}
        />
      );
    }

    if (selectedContest.type === "loteria-popular") {
      return (
        <LoteriaPopularCotacoes
          tipoCotacoes={tipoCotacoes}
          nomeJogo={selectedContest.objTipoJogo.vchNome.toLowerCase()}
          type={selectedContest.type}
        />
      );
    }

    switch (sntTipoJogo) {
      case 7777:
        return (
          <KenoCotacoes
            tipoCotacoes={tipoCotacoes}
            nomeJogo={selectedContest.objTipoJogo.vchNome.toLowerCase()}
          />
        );
      default:
        return (
          <ConcursosCotacoes
            tipoCotacoes={tipoCotacoes}
            nomeJogo={selectedContest.objTipoJogo.vchNome.toLowerCase()}
          />
        );
    }
  }, []);

  return (
    <RenderCotacoes sntTipoJogo={selectedContest.objTipoJogo.sntTipoJogo} />
  );
}

export function TabelaDeCotacao({ type, nomeValor, title }) {
  if (!nomeValor) {
    return null;
  }

  return (
    <div className="cotacoes-lopo-div">
      <table>
        <thead>
          <tr>
            <th>{type === "super-time" ? "Times" : "Modalidade"}</th>
            <th>Cotação</th>
          </tr>
        </thead>
        <tbody>
          {nomeValor.map((nv) => (
            <tr key={nv.key}>
              <td>{nv.nome}</td>
              <td>{R$(nv.valor)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function TabelaDeCotacaoConcurso({ acertosValor }) {
  const hasMegaBolaValue = false;
  // const hasMegaBolaValue = acertosValor.reduce(
  //   (valor, item) =>
  //     item.chances
  //       ? !!item.chances.reduce(
  //           (value, chance) => !!chance.valorMegaBola || !!value,
  //           false
  //         ) || !!valor
  //       : false,
  //   false
  // );

  if (!acertosValor) {
    return null;
  }

  return (
    <div className="cotacoes-concursos-div">
      {acertosValor.every((av) => !!av.chances) ? (
        acertosValor.map((av) => {
          return (
            <div className="concurso-container">
              <header>{av.tamanho} números jogados</header>
              <table>
                <thead>
                  <tr>
                    <th>Acertos</th>
                    <th>Cotação ( a cada 1 real jogado )</th>
                    {hasMegaBolaValue && (
                      <th>Cotação de Bola Premiada ( a cada 1 real jogado )</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {av.chances.map((chance) => (
                    <tr>
                      <td>{chance.acertos}</td>
                      <td>{R$(chance.valor)}</td>
                      {hasMegaBolaValue && (
                        <td>
                          {chance.valorMegaBola
                            ? R$(chance.valorMegaBola)
                            : "-"}
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        })
      ) : (
        <table>
          <thead>
            <tr>
              <th>Números jogados e acertados</th>
              <th>Cotação ( a cada 1 real jogado )</th>
            </tr>
          </thead>
          <tbody>
            {acertosValor.map((av) => (
              <tr>
                <td>{av.tamanho}</td>
                <td>{R$(av.premioMaximo)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/newDesign/components/cotacoes/index.jsx